import logoLixeira from '../../assets/trash (1).png'
import './card.css'

export const Card = ({listTransactions, setListTransactions, transaction}) =>{

    const deleteCard = () =>{
        const lista = [...listTransactions]
        const index = lista.findIndex( element => element.id === transaction.id);
        lista.splice(index, 1);

        setListTransactions(lista);
        
    }

    return(
        <li className='container-card'>
            <div className='container-card-description'>
                <h2>{transaction.description}</h2>
                <span>{transaction.option}</span>
            </div>
            <div className='container-card-value'>
                <p>R$ {transaction.value},00</p>
                <img src={logoLixeira} alt='logo-lixeira' onClick={()=> deleteCard()}/>
            </div>
        </li>
    )
}